import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { RiEdit2Fill } from 'react-icons/ri';
import { Expertise } from '../../types/expertise';
import SkillBadge from '../CommonComps/Badges/SkillBadge';
import UpdateServiceExpertiseModal from '../CommonComps/Modals/UpdateServiceExpertiseModal';
import SectionHeader from '../CommonComps/Titles/SectionHeader';

const ServiceExpertise = ({
  expertiseList,
}: {
  expertiseList: Array<Expertise>;
}) => {
  // integration of react hooks here
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // rendering service expertise component here
  return (
    <div className='p-5 rounded-xl shadow-academia-sm'>
      <SectionHeader
        headerText='Service Expertise'
        extraElement={
          <button
            title='Edit Provided Services'
            onClick={() => setShowEditModal((state) => !state)}
            className='text-base-white bg-base-cyan border border-base-cyan p-1 rounded-md hover:opacity-70 active:scale-95 duration-300'
          >
            <RiEdit2Fill className='size-5' />
          </button>
        }
      />

      {expertiseList.length ? (
        <div className='flex flex-wrap items-center gap-3'>
          <div className='flex flex-wrap items-center gap-3'>
            {expertiseList.map((service) => (
              <SkillBadge
                key={service.id}
                badgeLabel={service.service_name}
                color='#845ADF'
              />
            ))}
          </div>
        </div>
      ) : (
        <p className='text-center font-medium text-base-red'>
          No Expertise Added!!
        </p>
      )}

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showEditModal && (
          <UpdateServiceExpertiseModal
            expertiseList={expertiseList}
            handleModalClose={() => setShowEditModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default ServiceExpertise;
